import configHelper from '@/config/ConfigHelper'
import { i18n } from '@/i18n'

function GenerateConfig () {
  return [
    {
      id: 1,
      name: i18n.t('tipos.servicio.web')
    }
  ]
}

export function TIPOS_SERVICIO (state) {
  return configHelper.getConfig(state, 'TIPOS_SERVICIO', GenerateConfig)
}

